import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/common.scss'



Vue.config.productionTip = false

Vue.use(ElementUI)

// 全局图片异常处理逻辑 (处理加载失败 或 src 缺失/为空的情况)
function fixImageFallback(target) {
  if (target.tagName === 'IMG') {
    const src = target.getAttribute('src');
    // 如果 src 缺失、为空，或者是无效字符串 "null"/"undefined"
    // 即使由于之前处理过而带有 data-fallback，只要 src 现在为空，我们依然尝试修复 (应对 Vue 重新渲染清空 src)
    if (!src || src.trim() === '' || src === 'null' || src === 'undefined') {
      applyFallback(target);
    }
  }
}

function applyFallback(target) {
  const defaultimg = target.getAttribute('defaultimg');
  const globalDefault = '/imgs/default.jpg';
  const currentSrc = target.getAttribute('src');

  // 1. 优先尝试元素自身的 defaultimg (业务默认图)
  // 如果当前 src 不是 defaultimg，我们尝试切换过去，且暂不标记 data-fallback 以允许下一级降级
  if (defaultimg && defaultimg !== 'null' && defaultimg !== 'undefined' && currentSrc !== defaultimg) {
    target.src = defaultimg;
  } 
  // 2. 如果没有业务图，或者业务图已经尝试过且失败了，则尝试全局默认图
  else if (currentSrc !== globalDefault) {
    target.src = globalDefault;
    target.setAttribute('data-fallback', 'true'); // 标记最后一级降级，防止死循环
  } 
  // 3. 所有降级都试过了，给它最后的标记
  else {
    target.setAttribute('data-fallback', 'true');
  }
}

// 1. 监听常规加载失败 (如 404)
window.addEventListener('error', function (e) {
  const target = e.target;
  if (target.tagName === 'IMG' && !target.getAttribute('data-fallback')) {
    applyFallback(target);
  }
}, true);

// 2. 监听 DOM 变化 (捕获初始缺失 src、动态生成、以及属性变化)
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // 元素节点
          if (node.tagName === 'IMG') {
            fixImageFallback(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('img').forEach(fixImageFallback);
          }
        }
      });
    } else if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
      fixImageFallback(mutation.target);
    }
  });
});
observer.observe(document.documentElement, { 
  childList: true, 
  subtree: true, 
  attributes: true, 
  attributeFilter: ['src'] 
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
